module.exports = __webpack_public_path__ + "static/media/Electronics.1aa7fa36.png";